var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "96px",
    height: "96px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8,8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.05078,9.94922c-0.525,-0.025 -0.95117,0.05078 -0.95117,0.05078l4,6l-4,5.90039c0,0 1.79961,0.3 2.59961,-0.5c0.5,-0.5 0.8,-1.00039 2.5,-3.40039c0.3,-0.5 0.60156,0 0.60156,0c1.5,2 1.89961,2.80039 2.59961,3.40039c0.9,0.7 2.59961,0.5 2.59961,0.5l-4,-5.90039l3.90039,-6c0,0 -1.7,-0.3 -2.5,0.5c-0.6,0.6 -1.19961,1.4 -2.59961,3.5c0,0 -0.30156,0.5 -0.60156,0c-1.4,-2 -1.99961,-2.9 -2.59961,-3.5c-0.4,-0.4 -1.02383,-0.52578 -1.54883,-0.55078zM0.41992,9.99023c-0.14141,-0.00664 -0.28242,-0.00273 -0.41992,0.00977l3.19922,12c0,0 1,0.00078 1.5,-0.19922c0.7,-0.3 1.00039,-0.60117 1.40039,-2.20117c0.4,-1.4 1.4,-5.7 1.5,-6c0.2,-0.7 0.50117,-0.7 0.70117,0c0.1,0.3 1.1,4.5 1.5,6c0.4,1.6 0.69844,1.90117 1.39844,2.20117c0.6,0.3 1.60156,0.19922 1.60156,0.19922l3.19922,-12c-1.1,-0.1 -2.4,0.49922 -2.5,1.69922l-1.69922,6.40039l-1.40039,-5.19922c-0.3,-1.5 -1.00078,-2.30078 -2.30078,-2.30078c-1.3,0 -1.89883,0.70078 -2.29883,2.30078l-1.40039,5.19922l-1.70117,-6.40039c-0.2625,-1.1375 -1.28945,-1.6625 -2.2793,-1.70898zM19.59961,10c0,0 -0.79883,-0.00078 -1.29883,0.19922c-0.6,0.3 -0.80078,0.90039 -0.80078,2.40039c0,0 0.30078,-0.3 0.80078,-0.5c1.4,-0.5 1.29883,-1.49961 1.29883,-2.09961zM19.5,12v0.07617c0.02433,-0.04351 0.03013,-0.07617 0,-0.07617zM19.5,12.07617c-0.05642,0.10093 -0.25023,0.28408 -0.59961,0.42383c-0.3,0.2 -0.60039,0.30039 -0.90039,0.40039c-0.7,0.3 -0.59961,0.69922 -0.59961,1.69922v7.40039c0,0 0.79883,0.10078 1.29883,-0.19922c0.7,-0.3 0.80078,-0.70117 0.80078,-2.20117z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWix);
export default __webpack_public_path__ + "static/media/wix.ddf30f3a18d930858e71f6fb9fae3605.svg";
export { ForwardRef as ReactComponent };